import React from 'react';

interface GlareHoverProps {
  width?: string;
  height?: string;
  background?: string;
  borderRadius?: string;
  borderColor?: string;
  children: React.ReactNode;
  glareColor?: string;
  glareOpacity?: number;
  glareAngle?: number;
  glareSize?: number;
  transitionDuration?: number;
  playOnce?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const GlareHover: React.FC<GlareHoverProps> = ({
  width = "auto",
  height = "auto",
  background = "transparent",
  borderRadius = "inherit",
  borderColor = "transparent",
  children,
  glareColor = "#ffffff",
  glareOpacity = 0.3,
  glareAngle = -30,
  glareSize = 300,
  transitionDuration = 800,
  playOnce = false,
  className = "",
  style = {},
}) => {
  const hex = glareColor.replace("#", "");
  let rgba = glareColor;
  if (/^[0-9A-Fa-f]{6}$/.test(hex)) {
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    rgba = `rgba(${r}, ${g}, ${b}, ${glareOpacity})`;
  } else if (/^[0-9A-Fa-f]{3}$/.test(hex)) {
    const r = parseInt(hex[0] + hex[0], 16);
    const g = parseInt(hex[1] + hex[1], 16);
    const b = parseInt(hex[2] + hex[2], 16);
    rgba = `rgba(${r}, ${g}, ${b}, ${glareOpacity})`;
  }

  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{
        width,
        height,
        background,
        borderRadius,
        border: `1px solid ${borderColor}`,
        ...style
      }}
    >
      <div
        className={`absolute inset-0 transition-[background-position] duration-${transitionDuration} ease-in-out ${
          playOnce ? 'glare-play-once' : ''
        }`}
        style={{
          background: `linear-gradient(${glareAngle}deg, transparent 60%, ${rgba} 70%, transparent)`,
          backgroundSize: `${glareSize}% ${glareSize}%`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '-100% -100%',
        }}
      />
      <div className="relative">{children}</div>
    </div>
  );
};

export default GlareHover;